var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/ProductionDesignInitiativeReview/ProductionDesignInitiativeReview.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/ProductionDesignInitiativeReview/ProductionDesignInitiativeReview.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_5 = "";t_5 += "\n    <div class=\"ProductionDesignInitiativeReview\">\n        <div class=\"ProductionDesignInitiativeReview-block\">\n            <div class=\"ProductionDesignInitiativeReview-blockWrapper\">\n                <h2>Review your application</h2>\n                <div class=\"ProductionDesignInitiativeReview-note\">All submissions are final. Once you pay your application fee, you will not be able to make changes. Please confirm the information you are submitting:</div>\n\n                <div class=\"ProductionDesignInitiativeReview-form\">\n\n                    <div class=\"ProductionDesignInitiativeReview-line\">\n                        <div class=\"ProductionDesignInitiativeReview-caption\">HAVE YOU APPLIED BEFORE?</div>\n                        <div class=\"ProductionDesignInitiativeReview-value\">";
t_5 += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"isAppliedBefore")?"Yes":"No"), env.opts.autoescape);
t_5 += "</div>\n                    </div>\n\n                    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"firstName")) {
t_5 += "\n                        <div class=\"ProductionDesignInitiativeReview-line\">\n                            <div class=\"ProductionDesignInitiativeReview-caption\">FIRST NAME</div>\n                            <div class=\"ProductionDesignInitiativeReview-value\">";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"firstName"), env.opts.autoescape);
t_5 += "</div>\n                        </div>\n                    ";
;
}
t_5 += "\n                    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"lastName")) {
t_5 += "\n                        <div class=\"ProductionDesignInitiativeReview-line\">\n                            <div class=\"ProductionDesignInitiativeReview-caption\">LAST NAME</div>\n                            <div class=\"ProductionDesignInitiativeReview-value\">";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"lastName"), env.opts.autoescape);
t_5 += "</div>\n                        </div>\n                    ";
;
}
t_5 += "\n                    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"daytimePhone")) {
t_5 += "\n                        <div class=\"ProductionDesignInitiativeReview-line\">\n                            <div class=\"ProductionDesignInitiativeReview-caption\">DAYTIME PHONE</div>\n                            <div class=\"ProductionDesignInitiativeReview-value\">";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"daytimePhone"), env.opts.autoescape);
t_5 += "</div>\n                        </div>\n                    ";
;
}
t_5 += "\n                    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"email")) {
t_5 += "\n                        <div class=\"ProductionDesignInitiativeReview-line\">\n                            <div class=\"ProductionDesignInitiativeReview-caption\">EMAIL ADDRESS</div>\n                            <div class=\"ProductionDesignInitiativeReview-value\">";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"email"), env.opts.autoescape);
t_5 += "</div>\n                        </div>\n                    ";
;
}
t_5 += "\n                    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"address")) {
t_5 += "\n                        <div class=\"ProductionDesignInitiativeReview-line\">\n                            <div class=\"ProductionDesignInitiativeReview-caption\">ADDRESS</div>\n                            <div class=\"ProductionDesignInitiativeReview-value\">";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"address"), env.opts.autoescape);
t_5 += "</div>\n                        </div>\n                    ";
;
}
t_5 += "\n                    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"addressLine2")) {
t_5 += "\n                        <div class=\"ProductionDesignInitiativeReview-line\">\n                            <div class=\"ProductionDesignInitiativeReview-caption\">ADDRESS LINE 2</div>\n                            <div class=\"ProductionDesignInitiativeReview-value\">";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"addressLine2"), env.opts.autoescape);
t_5 += "</div>\n                        </div>\n                    ";
;
}
t_5 += "\n                    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"city")) {
t_5 += "\n                        <div class=\"ProductionDesignInitiativeReview-line\">\n                            <div class=\"ProductionDesignInitiativeReview-caption\">CITY/TOWN</div>\n                            <div class=\"ProductionDesignInitiativeReview-value\">";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"city"), env.opts.autoescape);
t_5 += "</div>\n                        </div>\n                    ";
;
}
t_5 += "\n                    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"state")) {
t_5 += "\n                        <div class=\"ProductionDesignInitiativeReview-line\">\n                            <div class=\"ProductionDesignInitiativeReview-caption\">STATE/PROVINCE</div>\n                            <div class=\"ProductionDesignInitiativeReview-value\">";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"state"), env.opts.autoescape);
t_5 += "</div>\n                        </div>\n                    ";
;
}
t_5 += "\n                    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"zip")) {
t_5 += "\n                        <div class=\"ProductionDesignInitiativeReview-line\">\n                            <div class=\"ProductionDesignInitiativeReview-caption\">ZIP/POSTAL CODE</div>\n                            <div class=\"ProductionDesignInitiativeReview-value\">";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"zip"), env.opts.autoescape);
t_5 += "</div>\n                        </div>\n                    ";
;
}
t_5 += "\n                    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"country")) {
t_5 += "\n                        <div class=\"ProductionDesignInitiativeReview-line\">\n                            <div class=\"ProductionDesignInitiativeReview-caption\">COUNTRY</div>\n                            <div class=\"ProductionDesignInitiativeReview-value\">";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"country"), env.opts.autoescape);
t_5 += "</div>\n                        </div>\n                    ";
;
}
t_5 += "\n                    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"website1")) {
t_5 += "\n                        <div class=\"ProductionDesignInitiativeReview-line\">\n                            <div class=\"ProductionDesignInitiativeReview-caption\">PERSONAL WEBSITE #1</div>\n                            <div class=\"ProductionDesignInitiativeReview-value\"><a class=\"u-skipUrlParser\" target=\"_blank\" href=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"website1"), env.opts.autoescape);
t_5 += "\">";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"website1"), env.opts.autoescape);
t_5 += "</a></div>\n                        </div>\n                    ";
;
}
t_5 += "\n                    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"website2")) {
t_5 += "\n                        <div class=\"ProductionDesignInitiativeReview-line\">\n                            <div class=\"ProductionDesignInitiativeReview-caption\">PERSONAL WEBSITE #2</div>\n                            <div class=\"ProductionDesignInitiativeReview-value\"><a class=\"u-skipUrlParser\" target=\"_blank\" href=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"website2"), env.opts.autoescape);
t_5 += "\">";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"website2"), env.opts.autoescape);
t_5 += "</a></div>\n                        </div>\n                    ";
;
}
t_5 += "\n\n                    <div class=\"ProductionDesignInitiativeReview-line\">\n                        <div class=\"ProductionDesignInitiativeReview-caption\">LEGAL TO WORK</div>\n                        <div class=\"ProductionDesignInitiativeReview-value\">";
t_5 += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"isEligibleToWork")?"Yes":"No"), env.opts.autoescape);
t_5 += "</div>\n                    </div>\n\n                    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"howDidYouHear")) {
t_5 += "\n                        <div class=\"ProductionDesignInitiativeReview-line\">\n                            <div class=\"ProductionDesignInitiativeReview-caption\">HOW DID YOU HEAR</div>\n                            <div class=\"ProductionDesignInitiativeReview-value\">\n                                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"howDidYouHear") == "w") {
t_5 += " ";
t_5 += runtime.suppressValue("Website", env.opts.autoescape);
t_5 += " ";
;
}
t_5 += "\n                                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"howDidYouHear") == "p") {
t_5 += " ";
t_5 += runtime.suppressValue("Press Announcement", env.opts.autoescape);
t_5 += " ";
;
}
t_5 += "\n                                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"howDidYouHear") == "c") {
t_5 += " ";
t_5 += runtime.suppressValue("Career Office", env.opts.autoescape);
t_5 += " ";
;
}
t_5 += "\n                                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"howDidYouHear") == "ff") {
t_5 += " ";
t_5 += runtime.suppressValue("Film Festival", env.opts.autoescape);
t_5 += " ";
;
}
t_5 += "\n                                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"howDidYouHear") == "fr") {
t_5 += " ";
t_5 += runtime.suppressValue("Friend / Colleague / Instructor", env.opts.autoescape);
t_5 += " ";
;
}
t_5 += "\n                                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"howDidYouHear") == "m") {
t_5 += " ";
t_5 += runtime.suppressValue("Adg Member", env.opts.autoescape);
t_5 += " ";
;
}
t_5 += "\n                                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"howDidYouHear") == "tv") {
t_5 += " ";
t_5 += runtime.suppressValue("Tv / Broadcast / Film Professional", env.opts.autoescape);
t_5 += " ";
;
}
t_5 += "\n                                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"howDidYouHear") == "o") {
t_5 += " ";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"howDidYouHearOther"), env.opts.autoescape);
t_5 += " ";
;
}
t_5 += "\n                            </div>\n                        </div>\n                    ";
;
}
t_5 += "\n                </div>\n\n\n                <div class=\"ProductionDesignInitiativeReview-uploads\">\n                    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"narrativePdf")) {
t_5 += "\n                        <div class=\"ProductionDesignInitiativeReview-line\">\n                            <div class=\"ProductionDesignInitiativeReview-caption\">NARRATIVE STATEMENT</div>\n                            <div class=\"ProductionDesignInitiativeReview-value\"><a class=\"u-skipUrlParser\" target=\"_blank\" href=\"";
t_5 += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"narrativePdf")),"tempFile")?runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"narrativePdf")),"tempFile"):runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"narrativePdf")), env.opts.autoescape);
t_5 += "\" data-name=\"";
t_5 += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"narrativePdf")),"originalName")?runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"narrativePdf")),"originalName"):runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"narrativePdf")), env.opts.autoescape);
t_5 += "\"></a></div>\n                        </div>\n                    ";
;
}
t_5 += "\n\n                    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"resumePdf")) {
t_5 += "\n                        <div class=\"ProductionDesignInitiativeReview-line\">\n                            <div class=\"ProductionDesignInitiativeReview-caption\">RESUME</div>\n                            <div class=\"ProductionDesignInitiativeReview-value\"><a class=\"u-skipUrlParser\" target=\"_blank\" href=\"";
t_5 += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"resumePdf")),"tempFile")?runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"resumePdf")),"tempFile"):runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"resumePdf")), env.opts.autoescape);
t_5 += "\" data-name=\"";
t_5 += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"resumePdf")),"originalName")?runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"resumePdf")),"originalName"):runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"resumePdf")), env.opts.autoescape);
t_5 += "\"></a></div>\n                        </div>\n                    ";
;
}
t_5 += "\n\n                    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"recommendationPdf1")) {
t_5 += "\n                        <div class=\"ProductionDesignInitiativeReview-line\">\n                            <div class=\"ProductionDesignInitiativeReview-caption\">RECOMMENDATION 1</div>\n                            <div class=\"ProductionDesignInitiativeReview-value\"><a class=\"u-skipUrlParser\" target=\"_blank\" href=\"";
t_5 += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"recommendationPdf1")),"tempFile")?runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"recommendationPdf1")),"tempFile"):runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"recommendationPdf1")), env.opts.autoescape);
t_5 += "\" data-name=\"";
t_5 += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"recommendationPdf1")),"originalName")?runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"recommendationPdf1")),"originalName"):runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"recommendationPdf1")), env.opts.autoescape);
t_5 += "\"></a></div>\n                        </div>\n                    ";
;
}
t_5 += "\n\n                    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"recommendationPdf2")) {
t_5 += "\n                        <div class=\"ProductionDesignInitiativeReview-line\">\n                            <div class=\"ProductionDesignInitiativeReview-caption\">RECOMMENDATION 2</div>\n                            <div class=\"ProductionDesignInitiativeReview-value\"><a class=\"u-skipUrlParser\" target=\"_blank\" href=\"";
t_5 += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"recommendationPdf2")),"tempFile")?runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"recommendationPdf2")),"tempFile"):runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"recommendationPdf2")), env.opts.autoescape);
t_5 += "\" data-name=\"";
t_5 += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"recommendationPdf2")),"originalName")?runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"recommendationPdf2")),"originalName"):runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"recommendationPdf2")), env.opts.autoescape);
t_5 += "\"></a></div>\n                        </div>\n                    ";
;
}
t_5 += "\n\n                    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"portfolioPdf")) {
t_5 += "\n                        <div class=\"ProductionDesignInitiativeReview-line\">\n                            <div class=\"ProductionDesignInitiativeReview-caption\">VISUAL PORTFOLIO</div>\n                            <div class=\"ProductionDesignInitiativeReview-value\"><a class=\"u-skipUrlParser\" target=\"_blank\" href=\"";
t_5 += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"portfolioPdf")),"tempFile")?runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"portfolioPdf")),"tempFile"):runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"portfolioPdf")), env.opts.autoescape);
t_5 += "\" data-name=\"";
t_5 += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"portfolioPdf")),"originalName")?runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"portfolioPdf")),"originalName"):runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"portfolioPdf")), env.opts.autoescape);
t_5 += "\"></a></div>\n                        </div>\n                    ";
;
}
t_5 += "\n                </div>\n\n                ";
if((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"media") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"media")))) {
t_5 += "\n                    <div class=\"ProductionDesignInitiativeReview-media\">\n                        <div class=\"ProductionDesignInitiativeReview-line\">\n                            <div class=\"ProductionDesignInitiativeReview-caption\">MEDIA TRAILERS, CLIPS OR REELS:</div>\n                        </div>\n\n                        ";
frame = frame.push();
var t_8 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"media");
if(t_8) {t_8 = runtime.fromIterator(t_8);
var t_7 = t_8.length;
for(var t_6=0; t_6 < t_8.length; t_6++) {
var t_9 = t_8[t_6];
frame.set("media", t_9);
frame.set("loop.index", t_6 + 1);
frame.set("loop.index0", t_6);
frame.set("loop.revindex", t_7 - t_6);
frame.set("loop.revindex0", t_7 - t_6 - 1);
frame.set("loop.first", t_6 === 0);
frame.set("loop.last", t_6 === t_7 - 1);
frame.set("loop.length", t_7);
t_5 += "\n                            <div class=\"ProductionDesignInitiativeReview-embed\">\n                                ";
t_5 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_9),"videoCode")), env.opts.autoescape);
t_5 += "\n                            </div>\n                        ";
;
}
}
frame = frame.pop();
t_5 += "\n                    </div>\n                ";
;
}
t_5 += "\n            </div>\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("ProductionDesignInitiativeReview");
context.setVariable("ProductionDesignInitiativeReview", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/ProductionDesignInitiativeReview/ProductionDesignInitiativeReview.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/ProductionDesignInitiativeReview/ProductionDesignInitiativeReview.jinja
// module id = 129
// module chunks = 0